import Image from "next/image";

interface VerifiedProps {
  verified: boolean;
}

export const Verified = ({ verified }: VerifiedProps) => {
  return (
    <div className="size-5 flex items-center justify-center absolute top-0 right-0 z-20">
      {verified ? (
        <Image
          src="/images/icons/veified.svg"
          alt="verified"
          width={20}
          height={20}
        />
      ) : (
        <Image
          src="/images/icons/unveified.svg"
          alt="unverified"
          width={20}
          height={20}
        />
      )}
    </div>
  );
};
